/**
 * Сервис привязки Telegram-бота нотификаций рекрутеру (TASKNEIROKLYUCH-647 Bot API).
 * Endpoints в business-back: /api/v1/account/telegram/*.
 *
 * Использует сгенерированный OpenAPI-клиент {@link AccountTelegramApi} через
 * {@link apiService.getAuthenticatedClient()} — единый паттерн с остальными business-back
 * сервисами (complaints, branding и т.д.).
 */

import { apiService } from './apiService';
import type {
	AccountTelegramLinkTokenResponse,
	AccountTelegramLinkStatusResponse,
} from '../../generated-src/client/account-notifications/api';

export type TelegramLinkTokenResponse = AccountTelegramLinkTokenResponse;
export type TelegramLinkStatusResponse = AccountTelegramLinkStatusResponse;

/** Создаёт одноразовый deep link для привязки Telegram. TTL 10 минут. */
export async function createTelegramLinkToken(): Promise<TelegramLinkTokenResponse> {
	const client = apiService.getAuthenticatedClient();
	const response = await client.accountTelegram.createLinkToken();
	return response.data;
}

/** Статус привязки (для UI polling после клика «Подключить»). */
export async function getTelegramLinkStatus(): Promise<TelegramLinkStatusResponse> {
	const client = apiService.getAuthenticatedClient();
	const response = await client.accountTelegram.getTelegramLinkStatus();
	return response.data;
}

/** Отвязать Telegram — очистить chat_id. */
export async function unlinkTelegram(): Promise<void> {
	const client = apiService.getAuthenticatedClient();
	await client.accountTelegram.unlinkTelegram();
}
